export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(", ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export function formatINR(n) {
  if (n == null) return "₹0";
  return `₹${Number(n).toLocaleString("en-IN")}`;
}

export function formatHour(h) {
  const hh = Number(h);
  const ap = hh >= 12 ? "PM" : "AM";
  const d = ((hh + 11) % 12) + 1;
  return `${d}:00 ${ap}`;
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}
